import React from "react";

const InfoIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
            <path
                d="M9.28125 12V9M9.28125 6H9.28875M16.7812 9C16.7812 13.1421 13.4234 16.5 9.28125 16.5C5.13911 16.5 1.78125 13.1421 1.78125 9C1.78125 4.85786 5.13911 1.5 9.28125 1.5C13.4234 1.5 16.7812 4.85786 16.7812 9Z"
                stroke="#9DA6B3"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default InfoIcon;
